/* Native Shopify signup only. Subscription and code delivery run in Shopify, never in the browser. */
(() => {
  const dialog = document.querySelector('[data-email-pack]');
  if (!dialog) return;
  const demo = dialog.hasAttribute('data-demo');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const opening = dialog.querySelector('piranha-pack-opening');
  const key = 'piranha:welcome:email-confirmed-v1';
  const pendingKey = 'piranha:welcome:pending';
  const visitKey = 'piranha:welcome:shown-this-visit';
  const intro = dialog.querySelector('[data-email-intro]');
  const claim = dialog.querySelector('[data-email-claim]');
  const result = dialog.querySelector('[data-email-result]');
  const status = dialog.querySelector('[data-email-status]');
  let opener, timer, revealed = false, shown = false;
  const get = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const set = (storage, name, value) => { try { window[storage].setItem(name, value); } catch { /* Storage is optional. */ } };
  const open = () => {
    if (dialog.open || document.querySelector('[data-cart-drawer][open]')) return;
    clearTimeout(timer); shown = true; dialog.dataset.autoState = 'opened';
    opener = document.activeElement; dialog.showModal();
    if (!demo) { set('localStorage', key, String(Date.now())); set('sessionStorage', visitKey, '1'); }
  };
  const showClaim = (animate = true) => {
    const card = opening.querySelector('.pack-opening-flight');
    const previousTop = card.getBoundingClientRect().top;
    const alreadyRevealed = dialog.hasAttribute('data-revealed');
    dialog.dataset.revealed = ''; intro.hidden = true; claim.hidden = false;
    dialog.querySelector('[data-email-replay]')?.removeAttribute('hidden');
    status.textContent = ''; dialog.setAttribute('aria-labelledby', 'EmailPackClaimHeading');
    const nextTop = card.getBoundingClientRect().top;
    if (animate && !alreadyRevealed && dialog.open && !reduced.matches && opening.animate) {
      opening.animate([{ transform: `translateY(${previousTop - nextTop}px)` }, { transform: 'translateY(0)' }], { duration: 620, easing: 'cubic-bezier(.22,1,.36,1)' });
      claim.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 450, delay: 160, fill: 'backwards', easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    // Announce the reward without opening the mobile keyboard over the card.
    if (dialog.open) claim.querySelector('h2').focus({ preventScroll: true });
  };
  const reveal = () => { opening.play().catch(() => {}); };
  opening.addEventListener('pack-opening:start', () => {
    revealed = true; dialog.dataset.opening = ''; status.textContent = status.dataset.opening;
  });
  opening.addEventListener('pack-opening:complete', () => showClaim());
  opening.addEventListener('pack-opening:error', () => {
    revealed = false; delete dialog.dataset.opening;
    status.textContent = status.dataset.error;
  });
  const restoreReward = () => {
    revealed = true; dialog.dataset.opening = '';
    opening.finish(); showClaim(false);
  };
  const showResult = () => {
    restoreReward(); claim.hidden = true; result.hidden = false;
    dialog.setAttribute('aria-labelledby', 'EmailPackResultHeading');
    if (dialog.open) result.querySelector('h2').focus({ preventScroll: true });
  };
  dialog.querySelectorAll('[data-email-pack-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', (event) => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opening.pending) opening.finish();
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  document.querySelectorAll('[data-email-pack-open]').forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', open);
  });
  const launcher = document.querySelector('.email-pack-launcher');
  if (launcher) {
    const homepage = document.body.dataset.pageType === 'index';
    let positionFrame = 0;
    const placeLauncher = () => {
      positionFrame = 0;
      const height = launcher.offsetHeight;
      const mobile = innerWidth <= 749;
      const bottom = Math.min(150, Math.max(96, innerHeight * .16)) + (mobile ? 40 : 0);
      let top = Math.max(24, innerHeight - bottom - height);
      // Keep the full trust strip and carousel controls clear at every breakpoint.
      const obstacles = [...document.querySelectorAll('.hero-arrow--previous, .trust-marquee')]
        .map((element) => { const rect = element.getBoundingClientRect(); return { top: rect.top - 20, bottom: rect.bottom + 20 }; })
        .filter((rect) => rect.bottom > 0 && rect.top < innerHeight);
      const candidates = [top, ...obstacles.flatMap((rect) => [rect.top - height, rect.bottom])]
        .filter((candidate) => candidate >= 24 && candidate + height <= innerHeight - 20)
        .filter((candidate) => obstacles.every((rect) => candidate + height <= rect.top || candidate >= rect.bottom))
        .sort((a, b) => Math.abs(a - top) - Math.abs(b - top));
      launcher.toggleAttribute('data-controls-overlap', !homepage && !candidates.length);
      if (candidates.length) top = candidates[0];
      launcher.style.top = `${Math.round(top)}px`;
      launcher.toggleAttribute('data-footer-overlap', !homepage && (document.querySelector('.site-footer')?.getBoundingClientRect().top ?? Infinity) < top + height);
    };
    const schedulePosition = () => { if (!positionFrame) positionFrame = requestAnimationFrame(placeLauncher); };
    window.addEventListener('scroll', schedulePosition, { passive: true });
    window.addEventListener('resize', schedulePosition, { passive: true });
    window.addEventListener('pageshow', schedulePosition);
    placeLauncher();
  }
  dialog.querySelector('[data-email-replay]')?.addEventListener('click', (event) => {
    opening.reset(); revealed = false; delete dialog.dataset.opening; delete dialog.dataset.revealed;
    intro.hidden = false; claim.hidden = true; result.hidden = true;
    event.currentTarget.hidden = true; dialog.setAttribute('aria-labelledby', 'EmailPackHeading');
    reveal();
  });
  dialog.querySelector('[data-email-demo]')?.addEventListener('click', showResult);
  dialog.querySelector('form')?.addEventListener('submit', () => {
    set('sessionStorage', pendingKey, String(Date.now()));
  });
  const delay = (demo ? 1 : Number(dialog.dataset.delay) || 6) * 1000;
  const schedule = (wait = delay) => {
    clearTimeout(timer); dialog.dataset.autoState = 'scheduled';
    timer = setTimeout(() => {
      if (!autoEligible()) { dialog.dataset.autoState = 'cooldown'; return; }
      if (document.hidden || document.querySelector('.mobile-menu[open], dialog[open], [data-card-hover]') || document.activeElement?.matches('input, textarea, select')) {
        schedule(250); dialog.dataset.autoState = 'waiting-for-interaction'; return;
      }
      open();
    }, wait);
  };
  // The explicit demo remains replayable. Ordinary visits respect the same
  // once-per-visit limit and cooldown in both the local preview and storefront.
  const autoEligible = () => demo || !get('sessionStorage', visitKey) && Date.now() - Number(get('localStorage', key)) > 7 * 24 * 60 * 60 * 1000;
  const pending = Number(get('sessionStorage', pendingKey));
  if (!demo && dialog.querySelector('[data-email-success]') && pending && Date.now() - pending < 30 * 60 * 1000) {
    set('sessionStorage', pendingKey, '0'); open(); showResult();
  } else if (dialog.querySelector('[data-email-errors]')) { open(); restoreReward(); }
  else if (autoEligible()) schedule();
  else dialog.dataset.autoState = 'cooldown';
  window.addEventListener('pagehide', () => {
    clearTimeout(timer);
    if (revealed && !dialog.hasAttribute('data-revealed')) opening.finish();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted && !shown && autoEligible()) schedule(); });
})();
